/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import PropTypes from 'prop-types'

import { InputText } from 'primereact/inputtext'
import { Card } from 'primereact/card'
import { Button } from 'primereact/button'

import { exchangeValidation } from '../_validation'
import back from '../assets/images/back.svg'
import { userActions } from '../_actions'

function AddExchangeComponent({ exchangeId, addExchange, exchangeEntry, updateExchange, getExchangeById }) {
  const history = useHistory()
  const [errors, setErrors] = useState({})
  const [exchange, setExchange] = useState({})
  useEffect(() => {
    if (exchangeId) {
      getExchangeById(exchangeId)
    }
  }, [exchangeId])
  useEffect(() => {
    const updatedBy = 'updatedBy'
    if (exchangeEntry)
      setExchange({ ...exchangeEntry, [updatedBy]: userActions.getCurrentUser() })
    else {
      const createdBy = 'createdBy'
      setExchange(exchange => ({ ...exchange, [createdBy]: userActions.getCurrentUser() }))
    }
  }, [exchangeEntry])
  const saveExchange = () => {

    setErrors(exchangeValidation.mandatory(exchange))
    if (exchange.name !== '' && exchangeEntry == null) {
      addExchange(exchange)
    }

    if (exchangeEntry != null && exchange.name !== '') {
      updateExchange(exchange, exchangeId)
    }
  }
  function onChange(e) {
    const { name, value } = e.target
    setExchange(exchange => ({ ...exchange, [name]: value }))
  }

  const redirectBackToPreviousPage = () => {
    history.goBack()
  }
  return (
    <div className="p-col-10 dashboard">
      <div className="dashboard--wrapper">
        <Card className="cardBase addSector">
          <div className="p-grid">
            <div className="p-col-12 titleSec">
              <img src={back} alt={back} className="m-r-10 pointer" onClick={() => redirectBackToPreviousPage()} />
              <h4 className="display_1 m-b-0">{exchangeId ? 'Edit' : 'Add'} Exchange</h4>
            </div>
            <div className="p-col-6">
              <span className="inputHolder">
                <label className="inputHolder--label">Exchange Name<sup className="inputHolder--required">*</sup></label>
                <InputText className="inputHolder--inputBox" name="name" placeholder="Exchange Name" value={exchange?.name ? exchange.name : ''} onChange={onChange} maxLength="256" />
                {errors.name && (
                  <p className='space-danger'>{errors.name}</p>
                )}
              </span>
            </div>
            <div className="p-col-12 m-t-10">
              <Button label="Save" onClick={() => saveExchange()} className="p-button-raised p-button-rounded inputHolder--formBtn" />
            </div>
          </div>
        </Card>
      </div>
    </div>
  )
}
AddExchangeComponent.propTypes = {
  addExchange: PropTypes.func,
  exchangeEntry: PropTypes.object,
  updateExchange: PropTypes.func,
  exchangeId: PropTypes.number,
  getExchangeById: PropTypes.func,
}
export default AddExchangeComponent

